/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dr_Who2_TitleInputs */

const en_dr_who2_title = /** @type {(inputs: Dr_Who2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agencies + their clients`)
};

const id_dr_who2_title = /** @type {(inputs: Dr_Who2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agensi + kliennya`)
};

/**
* | output |
* | --- |
* | "Agencies + their clients" |
*
* @param {Dr_Who2_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const dr_who2_title = /** @type {((inputs?: Dr_Who2_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dr_Who2_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_dr_who2_title(inputs)
	return en_dr_who2_title(inputs)
});